import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({
  element: Component,
  requiredStatus,
  redirectTo,
  enforcePaidStatus = true,
}) => {
  const location = useLocation();
  const roleId = Number(localStorage.getItem("role_id"));
  const createdDate = localStorage.getItem("user_created_date");
  const subscriptionEndDate = localStorage.getItem("subscription_end_date");
  const hasValidSubscription =
    !subscriptionEndDate ||
    new Date(subscriptionEndDate).getTime() >= Date.now();
  const isPaidUser =
    localStorage.getItem("isPaidUser") === "true" && hasValidSubscription;
  const createdTime = createdDate ? new Date(createdDate).getTime() : NaN;
  const isTrialActive =
    roleId === 4 &&
    !Number.isNaN(createdTime) &&
    Date.now() - createdTime <= 3 * 24 * 60 * 60 * 1000;
  const hasFullAppAccess = isPaidUser || isTrialActive;
  const paidAppUserAllowedPaths = [
    "/patient/Dashboard",
    "/patient/Health_Tracker",
    "/patient/Garbha_Sanskar",
    "/patient/Contact",
    "/patient/profile",
  ];
  const unpaidAppUserAllowedPaths = [
    "/patient/Dashboard",
    "/patient/Contact",
    "/patient/profile",
  ];
  const appUserAllowedPaths = hasFullAppAccess
    ? paidAppUserAllowedPaths
    : unpaidAppUserAllowedPaths;

  if (roleId === 4 && !appUserAllowedPaths.includes(location.pathname)) {
    return <Navigate to={hasFullAppAccess ? "/patient/Garbha_Sanskar" : "/patient/Dashboard"} />;
  }

  if (roleId === 4 && hasFullAppAccess) {
    return <Component />;
  }

  if (!enforcePaidStatus) {
    return <Component />;
  }

  return isPaidUser === requiredStatus ? (
    <Component />
  ) : (
    <Navigate to={redirectTo} />
  );
};

export default ProtectedRoute;
